<sh-droppanel-select
    [isOpen$]="openDropdown$"
    [inOverflownContainer]="true"
    [openDirection]="dropdownDirection"
    [multiple]="true"
    [search]="true"
    [searchPlaceholderMsg]="'ui.search' | translate"
    [options]="options()"
    [initialSelectedValues]="initialSelectedValues()"
    (selectionState)="onColumnSelectionChanged($event)"
    (shClickOutside)="closeDropdown()"
>
    <sh-action-item [item]="columnSelectButton"></sh-action-item>
</sh-droppanel-select>
